import 'styles/index.scss'
import type { FC } from 'react'
import { memo, useMemo } from 'react'
import { Navigate } from 'react-router'

import Header from 'layout/Header/Header'
import { PATH_SEGMENT } from 'routes/pathSegments'
import type { RoutesConfigType } from 'routes/routes.utils'
import { generateRouter } from 'routes/routes.utils'

import { Home } from 'features/Home'
import { ChooseRoom } from 'features/Home/Book/ChooseRoom/ChooseRoom'

export const Guest: FC = memo(() => {
  const routesConfig: RoutesConfigType = useMemo(
    () => ({
      [PATH_SEGMENT.HOME]: <Home />,
      [`${PATH_SEGMENT.HOME}/${PATH_SEGMENT.BOOK}/:siteId/*`]: <ChooseRoom />,
      [PATH_SEGMENT.OTHER]: <Navigate to={PATH_SEGMENT.HOME} replace />,
    }),
    [],
  )

  return (
    <>
      <Header />

      <div className='application-layout__content' data-guest>
        <div className='application-layout__content-container'>{generateRouter(routesConfig)}</div>
      </div>
    </>
  )
})
